<br-main-layout
	[userMenuTemplate]="userMenuTemplate"
	[showMenu]="false"
	logoUrl="./assets/receitaAzul.svg"
	[mostrarBarraBrasil]="false"
  	[application]="app"
  	[showSessionTime]="false"
  	[user]="usuario">
	<br-alert-messages slot-main onlyFor="xxxyyy"></br-alert-messages>
	<div slot-main style="width: 100%; margin: auto;">
  		<router-outlet></router-outlet>
	</div>
	<my-loading slot-main></my-loading>
	<my-version slot-main></my-version>
</br-main-layout>

<br-footer [footer]="footer"></br-footer>

<ng-template #userMenuTemplateContent let-usuario="usuarioSuite" let-papeis="papeisSuite">
	<div class="user-menu-container">
    	<div class="usuario">{{usuario}}</div>
		<span *ngFor="let papel of papeis; index as i">
			{{papel.id}}
			<span *ngIf="i < papeis.length - 1">&comma;&nbsp;&nbsp;</span>
		</span>
	</div>
</ng-template>
<ng-template #userMenuTemplate>
	<ng-container *ngTemplateOutlet="userMenuTemplateContent;context:ctx"></ng-container>
</ng-template>
